// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1jkq3","colMin":"styles_colMin__c5rsM","colCheckbox":"styles_colCheckbox__3QCfZ"};